import {useTheme} from '@mui/material';

export default function MainLinearGradient({active}: { active?: boolean }) {
	if (active === undefined) active = true;
	const theme = useTheme();
	// @ts-ignore
	const first = active ? theme.palette.primary[400] : theme.palette.grey[400];
	// @ts-ignore
	const second = active ? theme.palette.primary[600] : theme.palette.grey[400];
	return (
		<>
			<stop stopColor={first}/>
			<stop offset="1" stopColor={second}/>
		</>
	);
}
